import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { api } from '@/lib/api'

export const Route = createFileRoute('/rpc/')({
  component: RpcPage,
})

function RpcPage() {
  const [endpoints, setEndpoints] = useState<any[]>([])
  const [url, setUrl] = useState('')
  const [token, setToken] = useState('')

  const load = () => api.getRpc().then(setEndpoints).catch(() => {})

  useEffect(() => { load() }, [])

  const handleAdd = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!url.trim()) return
    await api.addRpc({ url: url.trim(), token: token.trim() || undefined })
    setUrl('')
    setToken('')
    load()
  }

  const handleDelete = async (id: number) => {
    await api.deleteRpc(id)
    load()
  }

  const handleToggle = async (id: number, enabled: boolean) => {
    await api.updateRpc(id, { enabled: !enabled })
    load()
  }

  return (
    <div>
      <h1 style={{ fontSize: 20, marginBottom: 20 }}>RPC Endpoints</h1>

      <form onSubmit={handleAdd} className="card" style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        <input placeholder="RPC URL" value={url} onChange={(e) => setUrl(e.target.value)} style={{ flex: 1, minWidth: 200 }} />
        <input placeholder="Token (optional)" value={token} onChange={(e) => setToken(e.target.value)} style={{ width: 200 }} />
        <button type="submit" className="btn btn-primary">Add Endpoint</button>
      </form>

      <table>
        <thead>
          <tr>
            <th>URL</th>
            <th>Token</th>
            <th>Status</th>
            <th>Added</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {endpoints.map((ep: any) => (
            <tr key={ep.id}>
              <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{ep.url}</td>
              <td style={{ fontSize: 12, color: 'var(--text-dim)' }}>{ep.token ? '••••' : '-'}</td>
              <td>
                <span style={{
                  color: ep.enabled ? 'var(--green, #22c55e)' : 'var(--text-dim)',
                  fontSize: 12,
                }}>
                  {ep.enabled ? 'Enabled' : 'Disabled'}
                </span>
              </td>
              <td style={{ color: 'var(--text-dim)', fontSize: 12 }}>{new Date(ep.created_at).toLocaleString()}</td>
              <td style={{ display: 'flex', gap: 4 }}>
                <button
                  className="btn btn-sm"
                  style={{ background: 'var(--bg-hover)', color: 'var(--text)' }}
                  onClick={() => handleToggle(ep.id, ep.enabled)}
                >
                  {ep.enabled ? 'Disable' : 'Enable'}
                </button>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(ep.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {endpoints.length === 0 && <div style={{ color: 'var(--text-dim)', padding: 20, textAlign: 'center' }}>No RPC endpoints configured</div>}
    </div>
  )
}
